import script from "./scroll-content.vue?vue&type=script&setup=true&lang=ts"
export * from "./scroll-content.vue?vue&type=script&setup=true&lang=ts"

import "./scroll-content.vue?vue&type=style&index=0&id=31161ea4&lang=scss"

const __exports__ = script;

export default __exports__